<template>
  <v-card class="shadow-small round" height="100%">
    <v-container fluid>
      <v-row>
        <v-col sm="6" md="6">
          <span class="weight-l">
            {{ title }}
          </span>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="searchData"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="items.data"
        :items-per-page="5"
        :search="searchData"
        :item-key="items.id + 'a'"
        class="elevation-0"
        hide-default-footer
      >
        <template v-slot:item.title_b2b="{ item }">
          <v-list-item two-line class="px-0">
            <v-list-item-content>
              <v-list-item-title>{{ item.title_b2b }}</v-list-item-title>
              <v-list-item-subtitle>{{ item.title_ml }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>

        <template v-slot:item.brand="{ item }">
          <v-list-item two-line class="px-0">
            <v-list-item-content>
              <v-list-item-title>{{ item.brand }}</v-list-item-title>
              <v-list-item-subtitle>{{ item.model }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>

        <template v-slot:item.created_at="{ item }">
          <span>{{ item.created_at | dateStart }}</span>
        </template>

        <template v-slot:item.date_created="{ item }">
          <span>{{ item.date_created | dateStart }}</span>
        </template>

        <template v-slot:item.date_create_ticket="{ item }">
          <span>{{ item.date_create_ticket | dateStart }}</span>
        </template>

        <template v-slot:item.due_date="{ item }">
          <span>{{ item.due_date | dateEnd }}</span>
        </template>

        <template v-slot:item.cost="{ item }">
          <span>{{ item.cost | currency }}</span>
        </template>

        <template v-slot:item.total_amount="{ item }">
          <span>{{ item.total_amount | currency }}</span>
        </template>

        <template v-slot:item.sale_total="{ item }">
          <span>
            {{ item.sale_total | currency }}
          </span>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn
            x-small
            class="mx-2 text-capitalize teal--text caption elevation-0"
            color="grey lighten-3"
            @click="showShoppingCart(item)"
          >
            Detalle
          </v-btn>
          <v-btn
            :disabled="!authUser.status_invoice === true"
            x-small
            class="mx-2 text-capitalize primary--text caption elevation-0"
            color="grey lighten-3"
            @click="check_in(item)"
          >
            Facturar
          </v-btn>
          <v-btn
            x-small
            class="mx-2 text-capitalize caption elevation-0 blue--text"
            color="grey lighten-3"
            @click="sendEmailShoppingCart(item)"
          >
            Enviar Email
          </v-btn>
          <v-btn
            x-small
            class="mx-2 text-capitalize caption elevation-0 red--text"
            color="grey lighten-3"
            @click="orderDelete(item)"
          >
            Borrar
          </v-btn>
        </template>

        <template v-slot:item.buttons_check_in="{ item }">
          <v-btn
            x-small
            class="mx-2 text-capitalize teal--text caption elevation-0"
            color="grey lighten-3"
            @click="showCheckIn(item)"
          >
            Detalle
          </v-btn>
          <v-btn
            x-small
            class="mx-2 text-capitalize primary--text caption elevation-0"
            color="grey lighten-3"
            @click="checkInPDF(item)"
          >
            Factura PDF
          </v-btn>
          <v-btn
            x-small
            class="mx-2 text-capitalize caption elevation-0 blue--text"
            color="grey lighten-3"
            @click="sendEmailCheckIn(item)"
          >
            Enviar Email
          </v-btn>
          <v-btn
            x-small
            class="mx-2 text-capitalize caption elevation-0 red--text"
            color="grey lighten-3"
            @click="checkInDelete(item)"
          >
            Cancelar
          </v-btn>
        </template>

        <template v-slot:item.carbs="{ item }">
          <v-chip :color="getColor(item.carbs)" dark text>{{
            item.carbs
          }}</v-chip>
        </template>
      </v-data-table>

      <v-row justify="end">
        <v-col cols="end" v-if="Object.keys(items).length > 0">
          <v-spacer></v-spacer>
          <v-pagination
            v-if="Object.keys(items.pagination).length > 0"
            circle
            v-model="page"
            :length="items.pagination.lastPage"
            :total-visible="5"
          ></v-pagination>

          <v-spacer></v-spacer>
        </v-col>
      </v-row>

      <BillingDialog
        :active="dialog_verify"
        :data="items_verify"
        :cart_id="cart_id"
        @dialog:change="eventdialog"
      />

      <DetailsDialog
        v-if="dialog_details"
        :active="dialog_details"
        :data="items_details"
        :cart_id="cart_id"
        @dialog:change="eventdialog"
      />

      <CustomLoading :active="loading" />

      <v-dialog v-model="avilableItms" persistent width="900px">
        <v-card>
          <v-card-title
            >Productos no disponibles en su totalidad
            <p>
              Puede aceptarlo en la cantidad disponible pagando el mismo precio
            </p>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headersAvalible"
              :items="avilableData"
              :items-per-page="5"
              class="elevation-0"
            >
              <template v-slot:[`item.action`]="{ item }">
                <v-checkbox
                  v-if="item.current_quantity > 0"
                  v-model="item.status_delete"
                  label="Aceptar"
                ></v-checkbox>
                <div v-else style="color: #c72b27">No disponible</div>
              </template>

              <template v-slot:[`item.pvc`]="{ item }">
                {{ item.pvc | currency }}
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="closeAvaliable()" color="#b2aaaa" dark>Cerrar</v-btn>
            <v-btn @click="acceptAvalible()" color="primary">Confirmar</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-card>
</template>

<script>
import Swal from "sweetalert2";
import moment from "moment";
import BillingDialog from "./BillingDialog";
import DetailsDialog from "./DetailsDialog";
import CustomLoading from "./CustomLoading";
import axios from "axios";

export default {
  props: ["headers", "items", "search", "pagination", "title"],
  components: {
    BillingDialog,
    DetailsDialog,
    CustomLoading,
  },
  data() {
    return {
      loading: false,
      searchData: "",
      dialog_verify: false,
      dialog_details: false,
      items_verify: [],
      items_details: [],
      cart_id: "",
      progress: false,
      page: 1,
      avilableItms: false,
      itemsAvilable: {},
      avilableData: [],

      order_id: null,
      originalItem: {},

      headersAvalible: [
        { text: "Cantidad Solicitada", value: "quantity" },
        { text: "Cantidad Disponible", value: "current_quantity" },
        { text: "Descripcion", value: "title" },
        { text: "Precio Unitario Neto", value: "pvc" },
        { text: "Iva", value: "iva" },
        { text: "Accion", value: "action" },
      ],
    };
  },

  watch: {
    page(val) {
      this.emitPagination(val);
    },
  },

  computed: {
    CustomKey() {
      return this.data.items.name + "a";
    },
    authUser() {
      return this.$store.getters["auth/AUTH_USER"];
    },
  },
  filters: {
    dateEnd(value) {
      return moment(value).locale("es").fromNow();
    },
    dateStart(value) {
      return moment(value).locale("es").format("DD/MM/YYYY");
    },
  },
  methods: {
    emitPagination(page) {
      this.$emit("event:change", page);
    },

    getColor(item) {
      if (item == "En Espera" || item == "En Preparación") return "grey";
      else return "blue darken-1";
    },
    check_in(item) {
      // console.log("estoy en factura");
      Swal.fire({
        title: "Estas seguro que deseas Facturar?",
        text: "No podrás revertir esto",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#7160ec",
        cancelButtonColor: "#b2aaaa",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          this.checkAvailable(item);
          // this.verifyShoppingCart(item);
        }
      });
    },

    async checkAvailable(item) {
      try {
        this.order_id = item.id;
        this.originalItem = { ...item };
        const request = {
          publications: this.mapItem(item.items),
        };
        const response = await this.$store.dispatch(
          "shoppingCart/VALIDATE_STOCK",
          request
        );

        const checkStatus = response.data.filter((status) => !status?.status);

        if (!checkStatus.length) {
          this.verifyShoppingCart(item);
          return;
        }

        for (const iterator of checkStatus) {
          const publication = item.items.find(
            (index) => index.post_id === iterator.publication_id
          );

          if (publication) {
            this.avilableData.push({
              ...publication,
              current_quantity: iterator.available,
              status_delete: false,
            });
          }
        }

        this.avilableItms = true;
      } catch (error) {
        console.log(error);
      }
    },

    mapItem(item) {
      return item.map((index) => {
        return {
          publication_id: index.post_id,
          quantity: parseInt(index.quantity),
        };
      });
    },

    async showShoppingCart(item) {
      this.loading = true;
      try {
        const request = {
          order_id: item.id,
        };
        const response = await this.$store.dispatch(
          "shoppingCart/SHOW_SHOOPING_CART",
          request
        );
        this.loading = false;
        this.items_details = response.data;
        this.dialog_details = true;
      } catch (error) {
        this.loading = false;
        console.log("++", error);
      }
    },
    async verifyShoppingCart(item) {
      // console.log("estoy en verify",this.items.data);
      this.loading = true;

      try {
        this.cart_id = item.id;

        const request = {
          order_id: item.id,
          position: this.items.data.findIndex((index) => {
            return index.id == item.id;
          }),
        };

        console.log("request", request);

        await this.$store.dispatch("layout/VERIFY_SHOOPING_CART", request);

        this.loading = false;

        Swal.fire({
          title: "Facturado!",
          text: "Su pedido se encuentra en pedidos facturados",
          icon: "success",
          confirmButtonColor: "#7160ec",
        });
      } catch (error) {
        console.log("error", error);
        // if (error.response.status === 412) {
        //   this.loading = false;
        //   Swal.fire({
        //     title: "Lo sentimos !",
        //     text: error.response.data,
        //     icon: "error",
        //     confirmButtonColor: "#7160ec",
        //   });
        // } else if (error.response.status === 424) {
        //   this.loading = false;
        //   Swal.fire({
        //     title: "Lo sentimos !",
        //     text: error.response.data,
        //     icon: "error",
        //     confirmButtonColor: "#7160ec",
        //   });
        // } else if (error.response.status === 422) {
        //   this.dialog_verify = true;
        //   this.loading = false;
        //   this.items_verify = error.response.data;
        // } else {
        //   this.loading = false;
        //   Swal.fire({
        //     title: "Lo sentimos !",
        //     text: "consulte el admiistrador",
        //     icon: "error",
        //     confirmButtonColor: "#7160ec",
        //   });
        // }
      }
    },
    async showCheckIn(item) {
      this.loading = true;
      try {
        const request = {
          order_id: item.id,
        };
        console.log(request.order_id);
        const response = await this.$store.dispatch(
          "shoppingCart/SHOW_SHOOPING_CART",
          request
        );

        this.items_details = response.data;
        console.log("items_details", this.items_details);
        this.dialog_details = true;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("++", error);
      }
    },
    eventdialog(message) {
      // console.log(message);
      if (message == "error") {
        this.loading = false;
      }
      this.dialog_verify = false;
      this.dialog_details = false;
    },
    async checkInPDF(item) {
      this.loading = true;
      axios({
        method: "get",
        url: `http://127.0.0.1:3336/api/b2b/download_invoice?order_id=${item.id}`,
        responseType: "arraybuffer",
        headers: {
          Authorization: ` Bearer ${localStorage.getItem("token")}`,
        },
      })
        .then((response) => {
          this.loading = false;
          this.forceFileDownload(response, item.bill_number);
        })
        .catch((error) => console.log("error occured", error));
      // try {
      //   this.loading = true;
      //   const request = {
      //     id: item.id
      //   };
      //   const response = await this.$store.dispatch(
      //     "layout/CHECK_IN_PDF",
      //     request
      //   );
      //   console.log('***2',response.data)
      //   this.loading = false;
      // } catch (error) {
      //   this.loading = false;
      //   console.log("+++", error);
      // }
    },
    forceFileDownload(response, bill_number) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${bill_number}.pdf`); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    async sendEmailCheckIn(item) {
      this.loading = true;
      try {
        const request = {
          id: item.id,
        };
        await this.$store.dispatch("layout/CHECK_IN_EMAIL", request);

        Swal.fire({
          title: "Correo enviado con éxito",
          icon: "success",
          confirmButtonColor: "#7160ec",
        });

        // console.log('***3',response)
        this.loading = false;
      } catch (error) {
        this.loading = false;
        Swal.fire({
          title: "Lo sentimos !",
          text: error.response.data,
          icon: "error",
          confirmButtonColor: "#7160ec",
        });
        console.log("+++", error);
      }
    },
    async sendEmailShoppingCart(item) {
      this.loading = true;
      try {
        const request = {
          id: item.id,
        };
        await this.$store.dispatch("layout/SHOPPING_CART_EMAIL", request);

        Swal.fire({
          title: "Correo enviado con éxito",
          icon: "success",
          confirmButtonColor: "#7160ec",
        });

        // console.log('***3',response)
        this.loading = false;
      } catch (error) {
        this.loading = false;
        Swal.fire({
          title: "Lo sentimos !",
          text: error.response.data,
          icon: "error",
          confirmButtonColor: "#7160ec",
        });
        console.log("+++", error);
      }
    },
    checkInDelete(item) {
      try {
        Swal.fire({
          title: "Esta seguro que desea cancelar su factura?",
          text: "No podras revertir esto!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#7160ec",
          cancelButtonColor: "#b2aaaa",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cerrar",
        }).then(async (result) => {
          if (result.value) {
            const request = {
              id: item.id,
            };
            const response = await this.$store.dispatch(
              "layout/CHECK_IN_DELETE",
              request
            );

            // console.log('+++4',response)
            Swal.fire({
              title: "Cancelado!",
              text: response,
              icon: "success",
              confirmButtonColor: "#7160ec",
            });
          }
        });
      } catch (error) {
        console.log("+++", error);
      }
    },
    orderDelete(item) {
      try {
        Swal.fire({
          title: "Esta seguro que desea eliminar su pedido?",
          text: "No podras revertir esto!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#7160ec",
          cancelButtonColor: "#b2aaaa",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cerrar",
        }).then(async (result) => {
          if (result.value) {
            const request = {
              id: item.id,
              position: this.items.indexOf(item),
            };
            await this.$store.dispatch("layout/ORDER_DELETE", request);

            // console.log('+++4',response)

            Swal.fire({
              title: "Eliminado!",
              // text: response,
              icon: "success",
              confirmButtonColor: "#7160ec",
            });
          }
        });
      } catch (error) {
        console.log("+++", error);
      }
    },

    async acceptAvalible() {
      try {
        const request = {
          publications: this.mapAvalible(),
          order_id: this.order_id,
        };
        const response = await this.$store.dispatch(
          "shoppingCart/ACCEPT_VALIDATE_STOCK",
          request
        );
        console.log(response);
        this.verifyShoppingCart(this.originalItem);
        this.avilableItms = false;
      } catch (error) {
        console.log(error);
      }
    },

    mapAvalible() {
      return this.avilableData.map((item) => {
        return {
          publication_id: item.post_id,
          requested: item.quantity,
          available: item.current_quantity,
          status_delete: item.status_delete,
        };
      });
    },

    closeAvaliable() {
      this.avilableData = [];
      this.avilableItms = false;
    },
  },
};
</script>

<style>
.custom-title {
  overflow: hidden;
  white-space: nowrap;
}
.weight-l {
  font-size: 18px;
  font-weight: 500;
}
.width-p {
  max-width: 105px;
}
.shadow-large {
  box-shadow: 0 1px 15px rgba(27, 31, 35, 0.15) !important;
}
</style>
<!-- https://app.flextd.com/api/verify-sale-products/{id} -->
<!-- https://app.flextd.com/api/invoice-sale-products/{id} -->
